import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import VendorProtectedRoute from '../components/VendorProtectedRoute';
import ClerkLayout from '../components/ClerkLayout';
import VendorLayout from '../components/VendorLayout';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const SignupPage = lazy(() => import('../pages/signup/page'));
const ShopPage = lazy(() => import('../pages/shop/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const VendorLoginPage = lazy(() => import('../pages/vendor-login/page'));
const VendorSignupPage = lazy(() => import('../pages/vendor-signup/page'));
const VendorForgotPasswordPage = lazy(() => import('../pages/vendor-forgot-password/page'));
const VendorDashboardPage = lazy(() => import('../pages/vendor-dashboard/page'));
const ClerkTestPage = lazy(() => import('../pages/clerk-test/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  // Public + Clerk-protected routes
  {
    element: <ClerkLayout />,
    children: [
      {
        path: '/',
        element: <HomePage />,
      },
      {
        path: '/login',
        element: <LoginPage />,
      },
      {
        path: '/signup',
        element: <SignupPage />,
      },
      {
        path: '/clerk-test',
        element: <ClerkTestPage />,
      },
      {
        path: '/shop',
        element: <ShopPage />,
      },
      {
        path: '/cart',
        element: <CartPage />,
      },
      {
        path: '/checkout',
        element: <CheckoutPage />,
      },
    ],
  },
  // Vendor routes — NO Clerk, uses custom Supabase auth
  {
    element: <VendorLayout />,
    children: [
      {
        path: '/vendor-login',
        element: <VendorLoginPage />,
      },
      {
        path: '/vendor-signup',
        element: <VendorSignupPage />,
      },
      {
        path: '/vendor-forgot-password',
        element: <VendorForgotPasswordPage />,
      },
      {
        path: '/vendor-dashboard',
        element: (
          <VendorProtectedRoute>
            <VendorDashboardPage />
          </VendorProtectedRoute>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;